import { inject } from "@angular/core";
import { AuthService } from "./core/auth/services/auth.service";
import { SecurityService } from "./core/services/security.service";
import { Router } from "@angular/router";

export function appInitializerFactory(authService: AuthService, securityService: SecurityService) {
  const router = inject(Router);

  return async () => {
    try {
      // Autenticación y token válido
      await authService.handleRedirectResult();

      if (!authService.isAuthenticated()) {
        await authService.login();
        return;
      }

      let idToken = localStorage.getItem('idToken');
      if (!idToken || authService.isTokenExpired(idToken)) {
        await authService.acquireNewToken();
        idToken = localStorage.getItem('idToken');
      } else {
        authService.scheduleTokenRenewal(idToken);
      }

      await securityService.loadUserFunctionsAsync();
      } catch (error) {
        router.navigate(['/error']);
        return Promise.resolve();
      }
    };
  }
